import { render, staticRenderFns } from "./wizard-modal.vue?vue&type=template&id=52a60734&scoped=true&"
import script from "./wizard-modal.vue?vue&type=script&lang=js&"
export * from "./wizard-modal.vue?vue&type=script&lang=js&"
import style0 from "./wizard-modal.vue?vue&type=style&index=0&id=52a60734&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a60734",
  null
  
)

export default component.exports